export default __webpack_public_path__ + "53ee684288fd051a2642c5084c2f0a4a.png";